import type { ColumnFiltersState } from "@tanstack/react-table";

function serializeFilterValue(value: unknown): string {
	if (Array.isArray(value)) return JSON.stringify([...value].sort());
	return JSON.stringify(value);
}

export function detectFilterChanges(
	prev: ColumnFiltersState,
	next: ColumnFiltersState,
): { columnId: string; values: string[] }[] {
	const prevKeys = new Set(prev.map((f) => `${f.id}:${serializeFilterValue(f.value)}`));
	const nextIds = new Set(next.map((f) => f.id));
	const changes: { columnId: string; values: string[] }[] = [];

	for (const filter of next) {
		if (!prevKeys.has(`${filter.id}:${serializeFilterValue(filter.value)}`)) {
			changes.push({
				columnId: filter.id,
				values: Array.isArray(filter.value) ? filter.value.map(String) : [String(filter.value)],
			});
		}
	}

	for (const filter of prev) {
		if (!nextIds.has(filter.id)) {
			changes.push({ columnId: filter.id, values: [] });
		}
	}

	return changes;
}
